export const INFO_GET_PROJECT_INFO = 'INFO_GET_PROJECT_INFO'
export const INFO_SET_PROJECT_INFO = 'INFO_SET_PROJECT_INFO'
export const INFO_SET_LEGAL_INFO = 'INFO_SET_LEGAL_INFO'
export const INFO_SET_CARD_CONTENT = 'INFO_SET_CARD_CONTENT'
export const INFO_SET_LOADING = 'INFO_SET_LOADING'
export const INFO_SET_ERROR = 'INFO_SET_ERROR'
